<template>
  <div class="preview">
    <el-row type="flex">
      <el-col :span="18" :offset="3">
        <el-table
          ref="taskViewTable"
          :highlight-current-row="true"
          header-row-class-name="tableHeader"
          :stripe="true"
          :border="true"
          :data="selTaskQuestions"
        >
          <el-table-column width="60" type="index" label="题号"></el-table-column>
          <el-table-column width="60" prop="PageNum" label="页码"></el-table-column>
          <el-table-column width="80" prop="QuestionTypeName" label="题型"></el-table-column>
          <el-table-column label="题目">
            <template slot-scope="scope">
              <img
                style="max-width:100%;"
                v-if="scope.row.QuestionStemImage !== ''"
                :src="scope.row.QuestionStemImage"
              />
              <div style="text-align: left;color:#000" v-else v-html="scope.row.QuestionStem"></div>
            </template>
          </el-table-column>
          <el-table-column width="380" prop="Answer" align="left" label="正确答案 / 答案解析">
            <template slot-scope="scope">
              <div style="text-align: left; vertical-align: top; height: 100%;">
                <p>正确答案：</p>
                <div v-html="scope.row.Answer"></div>
                <p>答案解析：</p>
                <div v-html="scope.row.Explain"></div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="4">
        <div class="previewBtns">
          <el-button @click="print" type="primary">打印</el-button>
          <el-button @click="exportPdf" type="warning">导出</el-button>
        </div>
      </el-col>
    </el-row>

    <!--组卷出题的作业打印内容start-->
    <div id="printContainer" class="right print-container" ref="printContainer">
      <table
        class="question-page"
        border="0"
        cellpadding="0"
        cellspacing="0"
        v-for="(questionPage, pageIndex) in taskInfo.pages"
        :key="'pagePrint4-' + pageIndex"
      >
        <tr>
          <td style="vertical-align: baseline">
            <div style="width: 180mm;height: 267mm;">
              <p class="title-container" v-if="pageIndex == 0">
                <span class="paper-name">{{ taskInfo.TaskName }}</span>
              </p>
              <p class="chapter" v-if="pageIndex == 0">
                <span>{{ taskInfo.TeachingPlanTitle }}</span>
              </p>
              <div class="questions">
                <div
                  class="question-item"
                  v-for="(question, questionIndex) in questionPage.questions"
                  :id="'question' + question.ID"
                  :key="'print-question' + question.ID"
                  :ref="'question' + question.ID"
                >
                  <p class="question-type" v-if="countShowType(pageIndex, questionIndex)">
                    {{ question.QuestionTypeName }}
                    <span v-show="taskInfo.IsScore == 1">（共{{ countTypeTotalScore(question.QuestionType) }}分）</span>
                  </p>
                  <p class="question-no">
                    <span>{{ countType(pageIndex, questionIndex) }}、</span>
                    <span v-show="taskInfo.IsScore == 1">（本题{{ question.Score }}分）</span>
                  </p>
                  <div class="question-content">
                    <el-image
                      v-if="question.QuestionStemImage"
                      :src="question.QuestionStemImage"
                      :style="{
                        top: '0px',
                        left: '0px',
                        width: question.RegionW + 'px',
                        maxWidth: '179.5mm',
                        height: question.RegionH + 'px',
                        display: 'block',
                      }"
                    ></el-image>
                    <div v-else v-html="question.QuestionStem"></div>
                    <div :style="'height: ' + question.AdditionalAnswerArea + 'px'"></div>
                    <div class="answer-explain" v-show="false">
                      <div class="answer">
                        <span>【答案】</span>
                        <div v-html="question.Answer"></div>
                      </div>
                      <div class="explain">
                        <span>【解析】</span>
                        <div v-html="question.Explain"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <!--    打印内容end-->

    <!--导出pdf用的显示开始-->
    <div id="questionsPrint" class="Questions questionsPrint w-e-text-container">
      <div class="question-item questionsPrintItem w-e-text " v-for="(item, i) in selTaskQuestions" :key="i">
        <div class="splitPage" v-if="questionPageCount(i)"></div>
        <div class="questionContent">
          <div class="questionHtml" v-html="item.QuestionStem"></div>
        </div>
      </div>
    </div>
    <div id="question2ImgForPrint" class="question2ImgForPrint"></div>
    <!--导出pdf用的显示结束-->
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
//            <script src="https://cdn.jsdelivr.net/npm/wangeditor@latest/dist/wangEditor.min.js">
// import "./../../assets/js/wangEditor.min";

export default {
  name: "TaskView",
  props: {
    selTaskQuestions: {
      type: [Object, Array],
    },
    taskInfo: Object,
    chapter: String,
  },
  data() {
    return {
      paperPages: [],
    };
  },
  methods: {
    //在线出题  , 计算当前题目的分页
    questionPageCount(i, event) {
      // 如果加上该题刚好超过page页的倍数. 则当前页要分页.
      // 已经超过的, 则需要归0 , page页且加1,
      // let page = 1, pageHeight = 1122.52, nowheight = 0;
      let page = 1,
        pageHeight = 1046.52,
        nowheight = 0;
      for (let j = 0; j <= i; j++) {
        nowheight += this.selTaskQuestions[j].RegionH;
        //最后一个,且刚好大于 pageHeight,的倍数.
        if (i === j) {
          let isBig = nowheight > page * pageHeight;
          return isBig;
        }
        //不最最后一个, 则页数加1.
        if (nowheight > pageHeight * page) {
          nowheight = pageHeight * page + this.selTaskQuestions[j].RegionH;
          page++;
        }
      }
    },
    /**
     * 判断是否显示题型
     * @param pageIndex
     * @param questionIndex
     * @returns {boolean}
     */
    countShowType(pageIndex, questionIndex) {
      if (pageIndex == 0) {
        if (questionIndex == 0) {
          return true;
        } else {
          return (
            this.taskInfo.pages[pageIndex].questions[questionIndex - 1].QuestionType !=
            this.taskInfo.pages[pageIndex].questions[questionIndex].QuestionType
          );
        }
      } else {
        if (questionIndex == 0) {
          return (
            this.taskInfo.pages[pageIndex - 1].questions[this.taskInfo.pages[pageIndex - 1].questions.length - 1]
              .QuestionType != this.taskInfo.pages[pageIndex].questions[questionIndex].QuestionType
          );
        } else {
          return (
            this.taskInfo.pages[pageIndex].questions[questionIndex - 1].QuestionType !=
            this.taskInfo.pages[pageIndex].questions[questionIndex].QuestionType
          );
        }
      }
    },
    /**
     * 计算题型总分
     */
    countTypeTotalScore(questionType) {
      let totalScore = 0;
      for (let que of this.selTaskQuestions) {
        if (que.QuestionType == questionType) {
          totalScore += que.Score;
        }
      }
      return totalScore;
    },
    /**
     * 计算题号
     * @param pageIndex 页index
     * @param questionIndex 题的index
     * @returns {*|number}
     */
    countType(pageIndex, questionIndex) {
      let count = 0;
      if (pageIndex > 0) {
        for (let i = 0; i < pageIndex; i++) {
          count += this.taskInfo.pages[i].questions.length;
        }
      }
      count = count + questionIndex + 1;
      return count;
    },
    print() {
      if (this.taskInfo.isOnline === 1) {
        let nowPage = 0;
        let htmlDocument = `<!DOCTYPE html><html lang="en"><head>
              <meta charset="UTF-8">
              <title>${this.chapter}-任务单</title>
              <style>
                  @page{
                  margin:1cm;
                  }
                  @page print{
                  margin:1cm;
                  }
                  html, body {
                   font-size: 10.5pt;
                      padding:0;
                      margin:0;
                      color: #000;
                      -webkit-font-smoothing: antialiased;
                      font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif;
                  }
                  a{color:#000;}
                  font[size="7"] {
                    font-size: 26pt;
                  }
                  font[size="6"] {
                    font-size: 22pt;
                  }
                  font[size="5"] {
                    font-size: 18pt;
                  }
                  font[size="4"] {
                    font-size: 16pt;
                  }
                  font[size="3"] {
                    font-size: 14pt;
                  }
                  font[size="2"] {
                    font-size:12pt;
                  }
                  font[size="1"] {
                    font-size: 10.5pt;
                  }
                  .w-e-text img:hover{
                  box-shadow: none;
                  }
                  .w-e-text img{
                  vertical-align: top;
                  }
              </style>
              <script src="/static/js/wangEditor.min.js"><\/script>
          </head>
          <body>`;
        for (let i = 0; i < this.selTaskQuestions.length; i++) {
          let question = this.selTaskQuestions[i];
          //如果页码与题目不一样时.创建 页码
          if (nowPage !== question.PageNum) {
            //1.1, 如果是第一次 .则不加table结尾, 否则添加table结尾
            if (i !== 0) {
              htmlDocument += `</div></td></tr></table>`;
            }
            //1.2,无论是否第一次都要加table开始.
            htmlDocument += `<table border="0" cellpadding="0" cellspacing="0"  style="page-break-after:always;width:718.13px;height:277mm;word-break: break-all" ><tr><td style="vertical-align: baseline">`;
            htmlDocument += `<div  class="w-e-text-container" style="width: 718.13px;max-height: 277mm;max-width:718.13px;overflow: hidden">
                            <div  class="w-e-text" style="padding:0;overflow: hidden;border: 1px solid rgba(0, 0, 0, 0);">
                                ${question.QuestionStem}
                            </div>`;
            //1.3 加完之的一, 修改当前的page页.
            nowPage = question.PageNum;
            continue;
          }
          //2.0 如果相同, 直接添加题目.
          htmlDocument += `<div  class="w-e-text " style="padding:0;overflow: hidden;border: 1px solid rgba(0, 0, 0, 0);">
                                ${question.QuestionStem}
                            </div>`;
        }
        ///3.1, 最后一个Table补全.
        htmlDocument += "</td></tr></table></body></html>";

        //3.1 ,添加完题目后直接打印.
        let newWin = window.open("", "print");
        newWin.document.write(htmlDocument);
        newWin.document.close();
        setTimeout(function() {
          newWin.print();
          setTimeout(function() {
            newWin.close();
          }, 100);
        }, 500);
      } else if (this.taskInfo.Online == 4) {
        let htmlDocument = `<!DOCTYPE html><html lang="en"><head>
            <meta charset="UTF-8">
            <title> </title>
            <link rel="stylesheet" href="/static/css/paper-print.css?v=1.5"></link>
            <script src="/static/js/wangEditor.min.js"><\/script>
        </head>
        <body>`;
        let questionDiv = this.$refs.printContainer.innerHTML;
        htmlDocument = htmlDocument + questionDiv;
        htmlDocument += "</body></html>";
        //3.1 ,添加完题目后直接打印.
        let newWin = window.open("", "print");
        newWin.document.write(htmlDocument);
        newWin.document.close();
        setTimeout(function() {
          newWin.print();
          setTimeout(function() {
            newWin.close();
          }, 100);
        }, 500);
      } else {
        this.axios.post(window.url + "GetImagesForTaskList", { TaskListID: this.taskInfo.ID }).then((res) => {
          let imgSrc = res.data.data;
          let htmlStr = `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>${
            this.chapter
          }-任务单</title>
                  <style>
                  @page{
                  margin:0;
                  }
                  @page print{
                  margin:0;
                  }
                   html, body {
                      padding:0;
                      margin:0;
                      color: #000;
                      -webkit-font-smoothing: antialiased;
                      font-family: SimSun,'Avenir', Helvetica, Arial, sans-serif;
                  }
                  a{color:#000;}
                  img{
                  display: block;
                  border:0;
                  }
                  </style></head><body>`;
          //2 生成中间html
          for (let i = 0; i < imgSrc.length; i++) {
            htmlStr +=
              '<table border="0" cellpadding="0" cellspacing="0"  style="page-break-after:always;width:210mm;height:297mm;text-align: left" ><tr><td style="vertical-align: top">';
            htmlStr += `<img src="${imgSrc[i].PageImage}" style="max-width: 210mm;max-height: 297mm;">`;
            htmlStr += `</td></tr></table>`;
          }
          //3 生成结束组成完成html
          htmlStr += `</body></html>`;
          let newWin = window.open("", "print");
          newWin.document.write(htmlStr);
          newWin.document.close();
          setTimeout(function() {
            newWin.print();
            setTimeout(function() {
              newWin.close();
            }, 100);
          }, 500);
        });
      }
    },
    exportPdf() {
      let doc = new jsPDF("p", "mm", "a4");
      const options = {
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        scale: 4,
        dpi: window.devicePixelRatio * 4,
      };
      const loading = this.$loading({
        lock: true,
        text: "导出中……",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      /* let questionsPrint = document.getElementById("questionsPrint");
      let style = getComputedStyle(questionsPrint); */
      if (this.taskInfo.isOnline === 1) {
        let questionsPrint = document.getElementById("questionsPrint").querySelectorAll(".question-item");
        let question2ImgForPrint = document.getElementById("question2ImgForPrint");
        //遍历, 并找出节点.

        let splitPage = [];
        for (let i = 0; i < questionsPrint.length; i++) {
          let que = questionsPrint[i];

          if (que.querySelector(".splitPage")) {
            splitPage.push(i);
          }
        }
        splitPage.push(questionsPrint.length);

        //根据分页内容..组成新的DOM
        let pt2Html = "";
        for (let i = 0; i < splitPage.length; i++) {
          pt2Html += `<div style="padding:0 10mm;" id="questionsPrint${i}" class="Questions questionsPrint w-e-text-container">`;
          pt2Html += `<div style="font-size: 10.5pt;color:#000;text-align: center;height: 10mm;line-height:10mm;width:100%">${
            this.chapter
          }-任务单</div>`;
          if (i === 0) {
            for (let j = 0; j < splitPage[i]; j++) {
              pt2Html += questionsPrint[j].outerHTML;
            }
          } else {
            for (let j = splitPage[i - 1]; j < splitPage[i]; j++) {
              let spPage = questionsPrint[j].querySelector(".splitPage");
              if (spPage) {
                let node = questionsPrint[j].outerHTML;
                var pattern = /<div[^>]* class="splitPage"><\/div>/gi;
                var arr = node.split(pattern);
                pt2Html += arr.join("");
              } else {
                pt2Html += questionsPrint[j].outerHTML;
              }
            }
          }
          pt2Html += "</div>";
        }

        question2ImgForPrint.innerHTML = pt2Html;
        //根据question2ImgForPrint的内容生成四张图片.

        this.$nextTick(() => {
          for (let i = 0; i < splitPage.length; i++) {
            let quetoImg = document.getElementById("questionsPrint" + i);
            new html2canvas(quetoImg, options).then((canvas) => {
              let dataBase64 = canvas.toDataURL("image/jpeg", 1.0);
              if (i === splitPage.length - 1) {
                doc.addImage(dataBase64, "jpeg", 0, 0, 210, 297);
                doc.save(this.taskInfo.TaskName + ".pdf");
                loading.close();
              }
              doc.addImage(dataBase64, "jpeg", 0, 0, 210, 297);
              doc.addPage();
            });
          }
        });
      } else if (this.taskInfo.Online == 4) {
        let questionsPages = document.getElementById("printContainer").querySelectorAll(".question-page");
        //生成图片添加到imgs中

        this.$nextTick(() => {
          for (let i = 0; i < questionsPages.length; i++) {
            let quetoImg = questionsPages[i];
            new html2canvas(quetoImg, options).then((canvas) => {
              let dataBase64 = canvas.toDataURL("image/jpeg", 1.0);
              if (i === questionsPages.length - 1) {
                doc.addImage(dataBase64, "jpeg", 0, 0, 210, 297);
                doc.save(this.taskInfo.TaskName + ".pdf");
                loading.close();
              }
              doc.addImage(dataBase64, "jpeg", 0, 0, 210, 297);
              doc.addPage();
            });
          }
        });
      } else {
        //多张图片导出为pdf
        this.axios({
          method: "GET",
          url: window.url + "ExportPDF",
          params: {
            tasklistid: this.taskInfo.ID,
          },
        }).then((res) => {
          //异常处理.
          if (res.data.result !== 200) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
            return;
          }
          //获取正常数据.
          let a = document.createElement("a");
          let url = res.data.data;
          let filename = this.taskInfo.TaskName + ".pdf";
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          loading.close();
        });
      }
    },
  },
  mounted() {
    this.$refs.taskViewTable.setCurrentRow(this.selTaskQuestions[0]);
  },
};
</script>

<style scoped lang="less">
.preview {
  font-size: 16px;
  text-align: left;
  position: relative;

  .el-table {
    // filter: grayscale();
    /deep/ a {
      color: #000;
    }
  }

  /*/deep/ .w-e-text img{*/
  /*  vertical-align: top;*/
  /*}*/

  .previewBtns {
    position: fixed;
    width: 150px;
    top: 55%;
    margin-left: 20px;

    .el-button {
      width: 100%;
      display: block;
      margin-left: 0;
      margin-bottom: 30px;
    }
  }

  /*预览界面*/
  #printContainer {
    position: absolute;
    left: -9999px;
    z-index: -99999;
    &.right {
      width: 210mm;
      height: 100%;
      overflow: auto;

      .question-page {
        width: 210mm;
        min-height: 297mm;
        padding: 15mm;
        background: white;
        margin-bottom: 20px;
        box-sizing: border-box;
        border-collapse: separate;

        p {
          text-align: center;
          height: 30px;
          font-size: 11px;

          &.title-container {
            font-size: 20px;
          }
        }

        .question-item {
          width: 180mm;

          p.question-type {
            height: 30px;
            line-height: 30px;
            font-size: 18px;
            text-align: left;
            color: #333;
          }

          p.question-no {
            height: 25px;
            line-height: 25px;
            text-align: left;
            font-size: 15px;
            display: flex;
          }

          div.question-content {
            position: relative;
            border: none;
            .question-cover {
              display: none;
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              background: #ffeb3b;
              opacity: 0.75;
            }

            .answer-explain {
              border-top: 1px dashed rgb(221, 221, 221);
              margin: 0px 10px;
              padding: 5px 0;
            }

            div.answer,
            div.explain {
              display: flex;

              span {
                color: #409eff;
                font-size: 15px;
                margin-right: 10px;
                width: 70px;
              }
            }
          }
        }
      }
    }

    &.right::-webkit-scrollbar {
      width: 0;
    }
  }
  .questionsPrint {
    position: absolute;
    top: 0;
    z-index: -9999;
    left: -99999px;
    background: #fff;
    width: 210mm;
    height: 297mm;
    font-weight: normal;
    font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif;
    color: #000;
  }

  .question2ImgForPrint {
    position: absolute;
    top: 0;
    z-index: -9999;
    left: -99999px;
    width: 210mm;
    height: 297mm;
    font-weight: normal;
    font-family: SimSun, "Helvetica Neue", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    color: #000;
    word-break: break-all;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail/TaskView.vue